import { ColDef } from 'ag-grid-community'
import { AgCustomTooltipRenderer } from '../components/AgCustomTooltip'
import { DEFAULT_COLUMN_MIN_WIDTH, DEFAULT_COLUMN_WIDTH } from './constants'

const DEFAULT_TEXT_FILTER_PLACEHOLDER = 'Insert a value'

export const createMultiColumnFilterParams = (
  placeholder: string = DEFAULT_TEXT_FILTER_PLACEHOLDER
): ColDef['filterParams'] => ({
  filters: [
    {
      filter: 'agTextColumnFilter',
      filterParams: {
        filterPlaceholder: placeholder,
      },
    },
    {
      filter: 'agSetColumnFilter',
      filterParams: {
        buttons: ['clear'],
      },
    },
  ],
})

/**
 * Default AG Grid column configuration
 * Provides consistent behavior across all tables
 */
export const defaultColDef: ColDef = {
  width: DEFAULT_COLUMN_WIDTH,
  minWidth: DEFAULT_COLUMN_MIN_WIDTH,
  resizable: true,
  filter: 'agMultiColumnFilter',
  sortable: true,
  aggFunc: 'sum',
  cellStyle: (params: any) => {
    if (params.colDef.headerName !== 'Items') {
      return { color: 'rgba(0, 0, 0, 0.87)' }
    }

    return null
  },
  filterParams: createMultiColumnFilterParams(),
  menuTabs: ['filterMenuTab'],
  floatingFilter: false,
  suppressMenu: false,
  headerComponent: 'AgCustomHeader',
  headerComponentParams: { enableFilter: false },
  tooltipComponent: AgCustomTooltipRenderer,
  tooltipComponentParams: {
    alwaysShowTooltip: true,
    hide: true,
  },
}
